import { Button, Card, Chip } from '@mui/material';
import { Icon } from '@iconify/react';
import { AI_PLATFORMS, RESOURCE_PLATFORMS } from '../../../api/src/registry/registry-platform';
import { Stack, Typography } from '../components/mui-system';
import { PlatformIcon } from './RegistryCatalogTable';

export function RegistryAiPlaceholder({ compact = false }: { compact?: boolean }) {
  return (
    <Card variant="outlined" sx={{ p: compact ? 2 : { xs: 3, md: 4 } }}>
      <Stack gap={2}>
        <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap">
          <Icon icon="solar:chat-round-dots-bold-duotone" width={28} />
          <Typography variant={compact ? 'subtitle1' : 'h5'}>Присутствие в ответах ИИ</Typography>
          <Chip size="small" label="Скоро" variant="outlined" />
        </Stack>
        <Typography color="text.secondary">
          Проверки ещё не подключены. Здесь будут упоминания бренда и ссылки на наши ресурсы в
          ответах ИИ.
        </Typography>
        {!compact && (
          <>
            <Stack direction="row" gap={1} flexWrap="wrap">
              {AI_PLATFORMS.map((platform) => (
                <Chip
                  key={platform}
                  icon={<PlatformIcon platform={platform} />}
                  label={RESOURCE_PLATFORMS[platform].label}
                  variant="outlined"
                />
              ))}
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} gap={3} py={1}>
              <Stack flex={1} gap={0.5}>
                <Typography fontWeight={600}>Ручное сохранение</Typography>
                <Typography variant="body2" color="text.secondary">
                  Запрос, полный ответ, дата, упоминания и ссылки. Публичная ссылка на диалог — при
                  наличии.
                </Typography>
              </Stack>
              <Stack flex={1} gap={0.5}>
                <Typography fontWeight={600}>Автоматические проверки</Typography>
                <Typography variant="body2" color="text.secondary">
                  Выбранные запросы и сервисы, расписание и история ответов с основаниями для
                  каждого результата.
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="row" gap={1} flexWrap="wrap">
              <Button disabled variant="outlined">
                Сохранить ответ вручную
              </Button>
              <Button disabled variant="outlined">
                Настроить проверки
              </Button>
            </Stack>
            <Typography variant="caption" color="text.secondary">
              Публичные страницы ChatGPT, Claude и других сервисов уже можно добавлять в Реестр по
              ссылке. Их появление в Google или Яндексе учитывается как поисковая выдача.
            </Typography>
          </>
        )}
      </Stack>
    </Card>
  );
}
